import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const filterStepsByDogProfile = (
  steps: TStep[],
  dogProfile: Record<string, string> | null,
): TStep[] => {
  if (!dogProfile) return steps

  const hiddenStepsMap: { condition: boolean; pageId: PageId }[] = [
    { condition: !!dogProfile.gender, pageId: PageId.SEX_VC6 },
    { condition: !!dogProfile.ageGroupName, pageId: PageId.DOG_AGE_VC6 },
    { condition: !!dogProfile.isShelterDog, pageId: PageId.SHELTER_VC6 },
    {
      condition: !!dogProfile.breed_key || !!dogProfile.selectedBreedName,
      pageId: PageId.DOG_BREED_VC6,
    },
    {
      condition: (dogProfile.formattedBehaviorIssues?.length ?? 0) > 0,
      pageId: PageId.BEHAVIOR_VC6,
    },
    {
      condition: (dogProfile.formattedHealthIssues?.length ?? 0) > 0,
      pageId: PageId.HEALTH_ISSUES_VC6,
    },
    {
      condition: !!dogProfile.numberOfWalksPerDayName,
      pageId: PageId.WALK_VC6,
    },
  ]

  const hiddenPageIds = new Set(
    hiddenStepsMap.filter((item) => item.condition).map((item) => item.pageId),
  )

  return steps.filter((step) => !hiddenPageIds.has(step.pageId))
}
